import styles from "./FlashPlayer.module.scss"

import React, { RefObject } from "react"

interface Props {
  playerRef: RefObject<HTMLDivElement>
}

export default function FlashPlayer({ playerRef }: Props) {
  return (
    <div id="flashPlayer" ref={playerRef} className={`${styles.flash}`}>
      <p>
        <a href="http://www.adobe.com/go/getflashplayer">
          <img
            src="http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif"
            alt="Get Adobe Flash player"
          />
        </a>
      </p>
    </div>
  )
}
